module.exports = __webpack_public_path__ + "img/logo.d8697e05.png";